/**
 * Created by DejanK on 1/18/2017.
 *
 * rbInputDouble
 */
import angular from 'angular';

export default {
  template: templateFn,
  bindings: {
    model: '='
  }
};

templateFn.$inject = ['$attrs', 'RbInputTemplate'];
function templateFn($attrs, RbInputTemplate){
  const options = angular.extend(RbInputTemplate.readDefaultAttributes($attrs));
  return RbInputTemplate.doubleTemplate(options);
}
